import { connect } from 'react-redux';
import { preload } from 'react-isomorphic-render';
import _ from 'lodash';
import JobsHomePage from 'app/components/company/jobs-home';
import { fetchJobs, fetchJobsHomePage } from 'app/api/company-api';

const mapStateToProps = state => ({
  page: { ..._.get(state, 'company.jobsHomePage') },
  jobs: _.get(state, 'company.jobs'),
});

const JobsHomeContainer = connect(mapStateToProps)(preload(
  ({ dispatch }) => Promise.all([
    dispatch(fetchJobsHomePage()),
    dispatch(fetchJobs()),
  ]))(JobsHomePage),
);

export default JobsHomeContainer;



// WEBPACK FOOTER //
// ./app/containers/company/jobs-home.js